import styled from "@emotion/styled"
import Container from "@mui/material/Container"

export const Wrapper = styled(Container)`
  padding-top: 2em;
  padding-bottom: 2em;
  color: ${({ theme }) => theme.palette.text.content};
`
